
(function configServiceDefinition() {

    'use strict';

    function isEmptyObject(obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return false;
            }
        }
        return true;
    }

    function removeTrailingSlash(str) {
        if (str.indexOf('/') === str.length - 1)
            return str.substr(0, str.length - 1);
        return str;
    }

    function addStartSlash(str) {
        if (str.indexOf('/') !== 0)
            return '/' + str;
        return str;
    }

    angular.module('Config')
        .provider('config', [
            '$injector', function configProvider($injector) {

                var configuracion = {
                    apiEndPoints: {},
                    authEndpoint: null,
                    appEndpoint: null,
                    appName: 'CAF App',
                    appId: null,
                    termsAndConditionsTemplatePath: null,
                    defaultApiEndpointKey: null,
                    languageUrl: null,
                    localeUrl: null,
                    defaultApiScheme: 'http',
                    defaultAppScheme: 'http',
                    homeTitle: null,
                    homeText: null,
                    singleSignOn: 0,
                    fullTextMinLength: null,
                    searchTableMaxLength: null,
                    checkoutExpirationTime: null,
                    helpUrl: null,
                    customerCareUrl: null,
                    releaseName: null,
                    custom: {}
                };

                var appDefaultHost = window.location.hostname + ((window.location.port) ? (':' + window.location.port) : '');

                /*
                 * Permite guardar u obtener un valor custom de configuración.
                 */
                this.custom = function (key, value) {
                    if (arguments.length === 1) {
                        return configuracion.custom[key];
                    }
                    return (configuracion.custom[key] = value);
                };

                /*
                 * Permite especificar la url de lenguajes. (se puede utilizar el placeholder {lang})
                 */
                this.setlanguageUrl = function (languageUrl) {
                    configuracion.languageUrl = removeTrailingSlash(languageUrl);
                };

                /*
                 * Permite especificar la url de los locales. (se puede utilizar el placeholder {locale})
                 */
                this.setLocaleUrl = function (localeUrl) {
                    configuracion.localeUrl = removeTrailingSlash(localeUrl);
                };

                /*
                 * Permite especificar el scheme (aka protocol) utilizado para las URIs generadas por defecto para las api y aplicaciones. 
                 */
                this.setDefaultScheme = function (apiScheme, appScheme) {
                    configuracion.defaultApiScheme = apiScheme;
                    configuracion.defaultAppScheme = appScheme;
                };

                /*
                * Agrega un api endpoint.
                * key: Nombre del endpoint.
                * host: Host de la api sin contener el protocolo (ej: api.eticket-dev.com:8085)
                * path: Path requerido para acceder a la api.
                */
                this.addApiEndpoint = function (key, host, path) {
                    configuracion.apiEndPoints[key] = {
                        host: removeTrailingSlash(host),
                        path: addStartSlash(removeTrailingSlash(path)),
                        key: key
                    };
                };

                /*
                 * Especifica el endpoint por defecto.
                 */
                this.setDefaultApiEndpointKey = function (key) {
                    if (!configuracion.apiEndPoints[key])
                        throw 'No es posible especificar un endpoint por defecto si no existe. (' + key + ')';
                    return configuracion.defaultApiEndpointKey = key;
                };

                /*
                 * Retorna el endpoint con la key especificada o null si el mismo no existe.
                 */
                this.endpoint = function (key) {
                    return configuracion.apiEndPoints[key] || null;
                };

                /*
                 * Setea el endpoint de authentication.
                 * loginApiUrl: Url de la api que permite hacer login, refresh etc de los tokens (el MVC).
                 * externalProviderUrlBase: Url base de las páginas de login externo.
                 */
                this.setAuthEndpoint = function (loginApiUrl, externalProviderUrlBase) {
                    configuracion.authEndpoint = {
                        loginApiUrl: removeTrailingSlash(loginApiUrl),
                        externalProviderUrlBase: removeTrailingSlash(externalProviderUrlBase)
                    };
                };

                /*
                 * Permite especificar la url de la aplicación y los recursos.
                 * baseUrl: Url base de la aplicación.
                 * resourcesBaseUrl: Url base donde se encuentran los recursos de la aplicacion.
                 */
                this.setAppEndpoint = function (baseUrl, resourcesBaseUrl) {
                    configuracion.appEndpoint = {
                        baseUrl: removeTrailingSlash(baseUrl),
                        resourcesBaseUrl: removeTrailingSlash(resourcesBaseUrl)
                    };
                };

                /*
                 * Permite especificar el nombre de la aplicación.
                 */
                this.setAppName = function (name) {
                    configuracion.appName = name;
                };

                this.setAppId = function (appId) {
                    configuracion.appId = appID;
                };
                /*
                 * Permite especificar la ubicación del template html de los términos y condiciones de la aplicación.
                 * Si no se especifica, no se mostrarán.
                 * templatePath: El path de los terminos y condiciones relativo al path de resources base.
                 */
                this.settermsAndConditionsTemplatePath = function (templatePath) {
                    configuracion.termsAndConditionsTemplatePath = addStartSlash(templatePath);
                };

                /*
                 * Getters
                 */

                /*
                 * Reemplaza en una url de app el ~ por la base de la aplicación.
                 */
                this.appAbsoluteUrl = function (url) {
                    return url.replace('~', configuracion.appEndpoint.host);
                };

                /*
                 * Obtiene o especifica un valor de configuración custom.
                 */
                this.custom = function (key, value) {
                    if (arguments.length === 1) {
                        return configuracion.custom[key];
                    }
                    return (configuracion.custom[key] = value);
                };

                /*
                 * Retorna la url de un recurso de la aplicación.
                 */
                this.resourceUrl = function (path) {
                    return configuracion.appEndpoint.resourcesBaseUrl + addStartSlash(path);
                };

                /*
                 * Retorna la url de una página de la aplicación.
                 */
                this.appUrl = function (path) {
                    return configuracion.appEndpoint.baseUrl + addStartSlash(path);
                };

                /*
                 * Retorna la url base de los resouces de la aplicación.
                 */
                this.getResourcesBaseUrl = function () {
                    return configuracion.appEndpoint.resourcesBaseUrl;
                };

                /*
                 * Retorna la url absoluta del path especificado de la API con el endpoint especificado.
                 */
                this.apiUrl = function (path, endPointKey) {
                    var ep = endPointKey ? configuracion.apiEndPoints[endPointKey] : configuracion.defaultApiEndpoint;
                    if (!ep)
                        throw 'No se encontró el API endpoint ' + endPointKey;
                    return ep.host + ep.path + addStartSlash(path);
                };

                /*
                 * Retorna la url absoluta del path especificado de la API de autorización.
                 */
                this.authUrl = function (path) {
                    return configuracion.authEndpoint.loginApiUrl + addStartSlash(path);
                };

                /*
                 * Retorna la url absoluta del external provider.
                 */
                this.externalProviderUrl = function (path) {
                    return configuracion.authEndpoint.externalProviderUrlBase + addStartSlash(path);
                };

                /*
                 * Retorna el template de url de lenguajes.
                 */
                this.languageUrl = function () {
                    return configuracion.appLanguageUrl;
                };

                /*
                 * Retorna el template de url de locale.
                 */
                this.localeUrl = function () {
                    return configuracion.appLocaleUrl;
                };

                /*
                 * Retorna el nombre de la aplicación.
                 */
                this.appName = function () {
                    return configuracion.appName;
                };

                this.appId = function () {
                    return configuracion.appId;
                };

                /*
                 * Retorna los settings de la pantalla inicial.
                 */
                this.homeTitle = function () {
                    return configuracion.homeTitle;
                };

                this.homeText = function () {
                    return configuracion.homeText;
                };

                /*
                 * Retorna los settings de activacion de Single Sign-On
                 */
                this.singleSignOn = function () {
                    return configuracion.singleSignOn;
                };

                /*
                 * Retorna la configuracion del minumo de caracteres para full text.
                 */
                this.fullTextMinLength = function () {
                    return configuracion.fullTextMinLength;
                };

                /*
                 * Retorna la configuracion del maximo de caracteres para mostrar en las grillas de search.
                 */
                this.searchTableMaxLength = function () {
                    return configuracion.searchTableMaxLength;
                };

                /*
-                * Retorna la configuracion del tiempo que expira el checkout de un documento.
-                */
                this.checkoutExpirationTime = function () {
                    return configuracion.checkoutExpirationTime;
                }

                /*
                * Retorna el link de ayuda 
                */
                this.helpUrl = function () {
                    return configuracion.helpUrl;
                };

                /*
                * Retorna el nombre de la release
                */
                this.releaseName = function () {
                    return configuracion.releaseName;
                };

                /*
                * Retorna el link de customerCare 
                */
                this.customerCareUrl = function () {
                    return configuracion.customerCareUrl;
                };

                /*
                 * Retorna el path de los terminos y condiciones.
                 */
                this.termsAndConditionsTemplatePath = function () {
                    return configuracion.termsAndConditionsTemplatePath;
                };

                this.$get = function configServiceFactory() {

                    return {

                        /*
                         * Reemplaza en una url de app el ~ por la base de la aplicación.
                         */
                        appAbsoluteUrl: this.appAbsoluteUrl,

                        /*
                         * Obtiene o especifica un valor de configuración custom.
                         */
                        custom: this.custom,

                        /*
                         * Retorna la url de un recurso de la aplicación.
                         */
                        resourceUrl: this.resourceUrl,

                        /*
                         * Retorna la url de una página de la aplicación.
                         */
                        appUrl: this.appUrl,

                        /*
                         * Retorna la url base de los resouces de la aplicación.
                         */
                        getResourcesBaseUrl: this.getResourcesBaseUrl,

                        /*
                         * Retorna la url absoluta del path especificado de la API con el endpoint especificado.
                         */
                        apiUrl: this.apiUrl,

                        /*
                         * Retorna la url absoluta del path especificado de la API de autorización.
                         */
                        authUrl: this.authUrl,

                        /*
                         * Retorna la url absoluta del external provider.
                         */
                        externalProviderUrl: this.externalProviderUrl,

                        /*
                         * Retorna el template de url de lenguajes.
                         */
                        languageUrl: this.languageUrl,

                        /*
                         * Retorna el template de url de locale.
                         */
                        localeUrl: this.localeUrl,

                        /*
                         * Retorna el nombre de la aplicación.
                         */
                        appName: this.appName,

                        appId: this.appId,

                        /*
                         * Retorna los settings de la pantalla inicial.
                         */
                        homeTitle: this.homeTitle,
                        homeText: this.homeText,

                        /*
                         * Retorna los settings de activacion de Single Sign-On
                         */

                        singleSignOn: this.singleSignOn,

                        /*
                         * Retorna la cantidad de caracteres minima para full text.
                         */
                        fullTextMinLength: this.fullTextMinLength,

                        /*
                         * Retorna la cantidad de caracteres maxima para la grilla de busqueda.
                         */
                        searchTableMaxLength: this.searchTableMaxLength,
                        /*
                         * Retorna el timpo en minutos que expira el checkout de un documento.
                         */
                        checkoutExpirationTime: this.checkoutExpirationTime,

                        /*
                         * Retorna el path de los terminos y condiciones.
                         */
                        termsAndConditionsTemplatePath: this.termsAndConditionsTemplatePath,

                        /*
                         * Retorna la url de ayuda.
                         */
                        helpUrl: this.helpUrl,
                        /*
                         * Retorna la url del customer care
                         */
                        customerCareUrl: this.customerCareUrl,

                        /*
                        * Retorna el nombre de la release.
                        */
                        releaseName: this.releaseName

                };
                };

                /*
                 * Si se definió un organizationConfigProvider entonces tomo la configuración inicial del mismo.
                 */
                var organizationConfigProvider = null;

                try {
                    organizationConfigProvider = $injector.get('initialConfigProvider');

                    var orgCfg = organizationConfigProvider.getConfig();

                    for (var prop in orgCfg) {
                        if (orgCfg.hasOwnProperty(prop)) {
                            if (orgCfg[prop])
                                configuracion[prop] = orgCfg[prop];
                        }
                    }

                    // sanitizo los endpoints
                    angular.forEach(configuracion.apiEndPoints, function (ep) {
                        ep.host = removeTrailingSlash(ep.host),
                            ep.path = addStartSlash(removeTrailingSlash(ep.path))
                    });

                    if (configuracion.appEndpoint) {
                        if (configuracion.appEndpoint.baseUrl)
                            configuracion.appEndpoint.baseUrl = removeTrailingSlash(configuracion.appEndpoint.baseUrl);
                        if (configuracion.appEndpoint.resourcesBaseUrl)
                            configuracion.appEndpoint.resourcesBaseUrl = removeTrailingSlash(configuracion.appEndpoint.resourcesBaseUrl);
                    }

                    if (configuracion.authEndpoint) {
                        if (configuracion.authEndpoint.loginApiUrl)
                            configuracion.authEndpoint.loginApiUrl = removeTrailingSlash(configuracion.authEndpoint.loginApiUrl);
                        if (configuracion.authEndpoint.externalProviderUrlBase)
                            configuracion.authEndpoint.externalProviderUrlBase = removeTrailingSlash(configuracion.authEndpoint.externalProviderUrlBase);
                    }

                } catch (e) {
                    // no hay configuración especifica, solo los defaults
                }

                document.title = configuracion.appName;

                /*
                 * Seteo la configuración.
                 */
                if (!configuracion.apiEndPoints || isEmptyObject(configuracion.apiEndPoints)) {
                    throw 'Se debe configurar al menos un API endpoint.';
                }

                // seteo el default api endpoint
                if (configuracion.defaultApiEndpointKey) {
                    configuracion.defaultApiEndpoint = configuracion.apiEndPoints[configuracion.defaultApiEndpointKey];
                } else {
                    for (var ep in configuracion.apiEndPoints) {
                        if (configuracion.apiEndPoints.hasOwnProperty(ep)) {
                            configuracion.defaultApiEndpoint = configuracion.apiEndPoints[ep];
                            break;
                        }
                    }
                }

                // si no se seteo el app endpoint lo seteo
                if (!configuracion.appEndpoint)
                    configuracion.appEndpoint = {};
                if (!configuracion.appEndpoint.baseUrl)
                    configuracion.appEndpoint.baseUrl = configuracion.defaultAppScheme + appDefaultHost;
                if (!configuracion.appEndpoint.resourcesBaseUrl)
                    configuracion.appEndpoint.resourcesBaseUrl = configuracion.appEndpoint.baseUrl + '/app';

                // si no se seteo el auth endpoint lo seteo                        
                if (!configuracion.authEndpoint)
                    configuracion.authEndpoint = {};
                if (!configuracion.authEndpoint.loginApiUrl)
                    configuracion.authEndpoint.loginApiUrl = configuracion.defaultAppScheme + appDefaultHost;
                if (!configuracion.authEndpoint.externalProviderUrlBase)
                    configuracion.authEndpoint.externalProviderUrlBase = configuracion.defaultApiEndpoint.host + '/';

                // incrementar la version cuando se haga algún cambio a algun lenguaje
                if (!configuracion.appLanguageUrl)
                    configuracion.appLanguageUrl = configuracion.appEndpoint.resourcesBaseUrl + '/bundles/lang/{lang}.json';

                if (!configuracion.appLocaleUrl)
                    configuracion.appLocaleUrl = configuracion.appEndpoint.resourcesBaseUrl + '/bundles/lang/{{locale}}.js';
            }
        ]);

})();